import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const SignoutIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3158 16C25.3158 21.145 21.145 25.3158 16 25.3158C10.855 25.3158 6.6842 21.145 6.6842 16C6.6842 10.855 10.855 6.68421 16 6.68421C21.145 6.68421 25.3158 10.855 25.3158 16Z"
        fill={color}
        opacity={"0.12"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM16 25.3158C21.145 25.3158 25.3158 21.145 25.3158 16C25.3158 10.855 21.145 6.68421 16 6.68421C10.855 6.68421 6.68421 10.855 6.68421 16C6.68421 21.145 10.855 25.3158 16 25.3158Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1579 11.1053C12.1579 10.6402 12.5349 10.2632 13 10.2632H17.9196C18.3846 10.2632 18.7617 10.6402 18.7617 11.1053C18.7617 11.5703 18.3846 11.9474 17.9196 11.9474H13.8421V20.1579H17.9196C18.3846 20.1579 18.7617 20.5349 18.7617 21C18.7617 21.4651 18.3846 21.8421 17.9196 21.8421H13C12.5349 21.8421 12.1579 21.4651 12.1579 21V11.1053ZM18.578 13.0268C18.9078 12.6989 19.441 12.7004 19.7689 13.0301L22.2287 15.5038C22.5553 15.8323 22.5553 16.3629 22.2287 16.6914L19.7689 19.1651C19.441 19.4949 18.9078 19.4964 18.578 19.1684C18.2482 18.8405 18.2467 18.3073 18.5747 17.9775L19.6066 16.9397H15.5492C15.0841 16.9397 14.7071 16.5627 14.7071 16.0976C14.7071 15.6325 15.0841 15.2555 15.5492 15.2555H19.6066L18.5747 14.2177C18.2467 13.8879 18.2482 13.3547 18.578 13.0268Z"
        fill={color}
      />
    </svg>
  );
};
